import React, { useState, useContext } from 'react';

// mobx components
import AssetStoreContext from '../../stores/AssetStore';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { convertArrayToObject } from '../../tools/index';

// core utils
import { passivesListEs, passivesListEn } from '../../utils/Constants';

// core components
import HeaderSection from '../../components/header/HeaderSection';
import Passive from '../../components/Passive/Passive';

const useStyles = makeStyles(theme => ({
  root: {
    // display: 'flex',
  },
  formControl: {
    // margin: theme.spacing(3),
  },
  gridComponent: {
    flexGrow: 1
  },
  gridPaper: {
    paddingLeft: '15px',
    paddingRight: '15px',
    textAlign: 'justify'
  },
  gridLabel: {
    color: '#000',
    fontSize: '20px',
    lineHeight: '135%',
    width: '100%',
    wordBreak: 'break-word',
    margin: '0px',
    fontWeight: '600'
  }
}));

const SectionPassives = ({ lang }) => {
  const passivesList = lang.lang === 'es' ? passivesListEs : passivesListEn;
  const classes = useStyles();
  const assetStore = useContext(AssetStoreContext);
  const [assets, setAssets] = useState(convertArrayToObject(passivesList, 'value'));

  const handleSelectedChange = name => event => {
    if (event.target.checked) {
      // add goal to store
      assetStore.addAssetPassive(name, 'passivesList');
    } else {
      // remove store asset
      assetStore.removeAssetPassive(name, 'passivesList');
    }

    setAssets({
      ...assets,
      [name]: {
        ...assets[name],
        selected: event.target.checked
      }
    });
  };

  return (
    <>
      <HeaderSection tittle={lang.passiveTittle} />
      <div className={classes.gridComponent}>
        <Grid container spacing={3}>
          {passivesList.map((row, index) => (
            <Grid key={index} item md={7} xs={12}>
              <div className={classes.gridPaper}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={assetStore.passivesList.some(item => item.name === row.value)}
                      onChange={handleSelectedChange(row.value)}
                      value={row.value}
                    />
                  }
                  label={row.name}
                />
                {assetStore.passivesList.some(item => item.name === row.value) && (
                  <Passive passive={row} lang={lang} />
                )}
              </div>
            </Grid>
          ))}
        </Grid>
      </div>
    </>
  );
};

export default SectionPassives;
